import { useState } from 'react';

import PropTypes from 'prop-types';

import { useIntl } from '@zenbusiness/application-commons-intl';
import Grid from '@zenbusiness/zui/Grid';
import Text from '@zenbusiness/zui/Text';

import Modal from './Modal';

import { PLAN_PRODUCTS } from '../constants';
import * as Styled from '../OrderView.styles';

const IncludedInPlan = ({ orderTasks, loading }) => {
  const { formatMessage: fm } = useIntl();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTaskType, setModalTaskType] = useState(null);
  const ViewModal = PLAN_PRODUCTS[modalTaskType]?.ViewModal || (() => null);
  const productTitle = PLAN_PRODUCTS[modalTaskType]?.title;
  const currentTask = orderTasks.find((task) => task.orderTaskType === modalTaskType);

  const closeModal = () => setModalOpen(false);
  const openModal = (taskType) => () => {
    setModalTaskType(taskType);
    setModalOpen(true);
  };
  const tasks = orderTasks.filter((task) => !task.orderTaskType.includes('plan'));

  return (
    <>
      <Grid container direction="column" item spacing={2} sx={{ paddingTop: '16px' }}>
        {!loading &&
          tasks.map((task) => {
            const {
              title,
              description,
              hasDetails,
              ViewModal: HasViewModal,
            } = PLAN_PRODUCTS[task?.orderTaskType] || {};
            const hasClickableDetails = hasDetails && HasViewModal;

            if (title) {
              return (
                <Grid item key={task.orderTaskUuid}>
                  {hasClickableDetails ? (
                    <Styled.TitleButton variant="subtitle1" fontWeight="bold" onClick={openModal(task?.orderTaskType)}>
                      {fm({ id: title })}
                    </Styled.TitleButton>
                  ) : (
                    <Text variant="subtitle1" fontWeight="bold">
                      {fm({ id: title })}
                    </Text>
                  )}
                  {description && (
                    <Text variant="body2" sx={{ color: 'text.secondary' }}>
                      {fm({ id: description })}
                    </Text>
                  )}
                </Grid>
              );
            }
            return null;
          })}
      </Grid>
      {modalOpen && (
        <Modal
          Content={ViewModal}
          onClose={closeModal}
          open={modalOpen}
          task={currentTask}
          taskData={currentTask?.orderTaskData}
          title={productTitle ? fm({ id: productTitle }) : undefined}
          type={modalTaskType}
        />
      )}
    </>
  );
};

IncludedInPlan.propTypes = {
  orderTasks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loading: PropTypes.bool,
};

export default IncludedInPlan;
